import yup from "src/validators/yup.Module";

export interface ProdutoConsultaDto {
  nome: string;
}

export interface ProdutoConsultaComandoDto {
  valor?: number;
  quantidade?: number;
  codigoProduto: string;
}

export interface NFCeDto {
  serie: string;
  numeroNF: number;
  destinatario: DestinatarioNFCeDto | undefined;
  itens: ProdutoNFCeDto[];
  pagamento: MeioPagamentoNFCeDto[];
}

export interface DestinatarioNFCeDto {
  documento: string;
  nome: string;
  indicadorInscricaoEstadual: number;
}

export interface ProdutoNFCeDto {
  index: number;
  id: number;
  categoriaId: number;
  codigoProduto: string;
  codigoBarras: string;
  nome: string;
  descricao: string;
  codigoNcm: string;
  unidadeComercial: string;
  quantidadeComercial: number;
  valorUnitarioComercial: number;
  codigoBarrasTributavel: string;
  unidadeTributavel: string;
  quantidadeTributavel: number;
  valorUnitarioTributavel: number;
  indicaTotal: number;
  categoriaNome: string;
}

export interface MeioPagamentoNFCeDto {
  meioPagamento: number | undefined;
  valorPagamento: string;
}

export interface MeioPagamentoDto {
  meioPagamento: number;
  descricaoPagamento: string;
}

export const meioPagamento: MeioPagamentoDto[] = [
  { meioPagamento: 1, descricaoPagamento: "Dinheiro" },
  { meioPagamento: 2, descricaoPagamento: "Cheque" },
  { meioPagamento: 3, descricaoPagamento: "Cartão Crédito" },
  { meioPagamento: 4, descricaoPagamento: "Cartão Débito" },
  { meioPagamento: 5, descricaoPagamento: "Crédito Loja" },
  { meioPagamento: 10, descricaoPagamento: "Vale Alimentação" },
  { meioPagamento: 11, descricaoPagamento: "Vale Refeição" },
  { meioPagamento: 12, descricaoPagamento: "Vale Presente" },
  { meioPagamento: 13, descricaoPagamento: "Vale Combustível" },
  { meioPagamento: 15, descricaoPagamento: "Boleto Bancário" },
  { meioPagamento: 16, descricaoPagamento: "Depósito Bancário" },
  { meioPagamento: 17, descricaoPagamento: "Pagamento Instantâneo (PIX)" },
  { meioPagamento: 18, descricaoPagamento: "Transferência Bancária" },
  { meioPagamento: 19, descricaoPagamento: "Programa Fidelidade/Cashback" },
  { meioPagamento: 90, descricaoPagamento: "Sem Pagamento" },
  { meioPagamento: 99, descricaoPagamento: "Outros" },
];

export const ProdutoConsultaSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
